import { ConfigProvider } from 'antd'
import { Outlet } from 'react-router-dom'
import zhCN from 'antd/locale/zh_CN'
import { useEffect } from 'react'

// 管理端 页面入口, 有其他配置的可以在这里添加
export const AdminApp = () => {
  useEffect(() => {
    document.title = '课件官网管理后台'
  }, [])

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#FF7006',
          colorPrimaryHover: '#FF6D00',
        },
      }}
    >
      <Outlet />
    </ConfigProvider>
  )
}